module.exports = __webpack_public_path__ + "static/media/gen_img32.ef53521e.png";